import { useQuery } from '@tanstack/react-query';

import { API } from '@/shared/api';

import { USER_QUERY_KEYS } from '../lib/userQueryKeys';

export const useGetAccount = (enabled = false) =>
  useQuery({ enabled, queryFn: API.getAccount, queryKey: USER_QUERY_KEYS.account });
